import { defineMessages } from '../messages'

export const forcePasswordChangeMessages = defineMessages(
  {
    changeFailed: 'Ekki tókst að breyta lykilorði.',
    title: 'Breyttu lykilorðinu þínu',
    signedInAs: 'Þú ert innskráð(ur) sem',
    mustChange: 'Af öryggisástæðum þarftu að velja nýtt lykilorð áður en þú heldur áfram.',
    currentPassword: 'Núverandi lykilorð',
    newPassword: 'Nýtt lykilorð',
    confirmNewPassword: 'Staðfestu nýtt lykilorð',
    saving: 'Vista…',
    saveNewPassword: 'Vista nýtt lykilorð',
    logoutAndSwitch: 'Skrá út og skipta um notanda',
  },
  {
    en: {
      changeFailed: 'The password could not be changed.',
      title: 'Change your password',
      signedInAs: 'You are logged in as',
      mustChange: 'For security reasons, you need to choose a new password before you continue.',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      saving: 'Saving…',
      saveNewPassword: 'Save new password',
      logoutAndSwitch: 'Log out and switch user',
    },
    pl: {
      changeFailed: 'Nie udało się zmienić hasła.',
      title: 'Zmień hasło',
      signedInAs: 'Zalogowano jako',
      mustChange: 'Ze względów bezpieczeństwa musisz ustawić nowe hasło, zanim przejdziesz dalej.',
      currentPassword: 'Obecne hasło',
      newPassword: 'Nowe hasło',
      confirmNewPassword: 'Potwierdź nowe hasło',
      saving: 'Zapisywanie…',
      saveNewPassword: 'Zapisz nowe hasło',
      logoutAndSwitch: 'Wyloguj się i zmień użytkownika',
    },
  }
)
